import { useContext } from 'react';
import i18nContext from 'components/i18n-context';
import './SystemAccountsHeadRow.scss';

export const SYSTEM_ACCOUNTS_TABLE_HEADER = [
  {
    label: 'accountNumber'
  },
  {
    label: 'paymentProvider'
  },
  {
    label: 'iban'
  },
  {
    label: 'amount'
  },
  {
    label: 'currency'
  },
  {
    label: 'actions'
  }
];

const SystemAccountsHeadRow = () => {
  const i18n = useContext(i18nContext);

  return (
    <tr>
      {SYSTEM_ACCOUNTS_TABLE_HEADER.map((head) => (
        <th key={head.label} className={'system-accounts-table-head'}>
          <div className={'system-accounts-table-head-block'}>
            <span>{i18n.getMessage(`systemAccounts.table.header.${head.label}`)}</span>
          </div>
        </th>
      ))}
    </tr>
  );
};

export default SystemAccountsHeadRow;
